// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from '@/App'
import Message from '@/components/Message/Message.vue'
import CPLink from '@/scripts/CPLink.js'
import Croppa from 'vue-croppa'
import VueI18n from 'vue-i18n'
import EN from '../lang/en.json'
import DE from '../lang/de.json'
import router from '@/router'
import CPAdmin from '@/views/components/CPAdmin.vue'
import VueCookies from 'vue-cookies'
import _ from 'lodash';

import { Loading } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import { MdIcon, MdButton, MdBadge, MdDivider, MdRadio, MdField } from 'vue-material/dist/components';
import 'vue-material/dist/vue-material.min.css';
import 'vue-material/dist/theme/default.css';

// Vue material
Vue.use(MdIcon)
Vue.use(MdButton)
Vue.use(MdBadge)
Vue.use(MdDivider)
Vue.use(MdRadio)
Vue.use(MdField)

// Element Io
Vue.use(Loading);

Vue.use(Croppa)
Vue.use(VueI18n)
Vue.use(VueCookies)
VueCookies.config('1d')

Vue.config.productionTip = false
Vue.config.devtools = true

/** to change local language this.$i18n.locale = 'de' */ // vue path:'/:lang'
export const i18n =  new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  silentTranslationWarn: true, // to stop warning
  messages: {
    en : EN,
    de : DE
  }
})

  const routes = {
    '/': App,
    // '/cpadmin': CPAdmin,
    '/channel': App,
    '/alr': App,
  }


export const serverBus = new Vue()
Vue.component('message', Message)
Vue.component('CPLink', CPLink)

// directive for autofocus just add to <input v-focus/>
Vue.directive('focus', {
  inserted: function (el) {
    if(window.innerWidth > 680)
      el.focus()
  }
})

new Vue({
  el: '#MainChat',
  i18n,
  router,
  data: {
    currentRoute: window.location.pathname
  },
  mounted() {
      // Add lodash as vue prototype, can be accesed with this.$_.
      // for example this.$_.isEmpty(null)
      Object.defineProperty(Vue.prototype, '$_', { value: _ });

      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);

      window.addEventListener('resize', _ => {
          // The app needs a timeout to wait until the resize event if fully completed
          clearTimeout(window.resizedFinished);
          window.resizedFinished = setTimeout(() => {
              let vh = window.innerHeight * 0.01;
              document.documentElement.style.setProperty('--vh', `${vh}px`);
          }, 250);
      });
  },
  computed: {
    ViewComponent () {
      if(typeof routes[this.currentRoute] != 'undefined'){
        return routes[this.currentRoute]
      }else {
        return App
      }
    }
  },
  render (h) { return h(App) }
})
